// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateBlankClientPresentationMutationVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
}>;


export type CreateBlankClientPresentationMutation = { __typename?: 'Mutation', createBlankClientPresentation: { __typename?: 'ClientPresentationV2', id: string } };

export const Operations = {
  Mutation: {
    CreateBlankClientPresentation: 'CreateBlankClientPresentation' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const CreateBlankClientPresentationDocument = gql`
    mutation CreateBlankClientPresentation($householdID: ID!) {
  createBlankClientPresentation(householdID: $householdID) {
    id
  }
}
    `;
export type CreateBlankClientPresentationMutationFn = Apollo.MutationFunction<CreateBlankClientPresentationMutation, CreateBlankClientPresentationMutationVariables>;

/**
 * __useCreateBlankClientPresentationMutation__
 *
 * To run a mutation, you first call `useCreateBlankClientPresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlankClientPresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlankClientPresentationMutation, { data, loading, error }] = useCreateBlankClientPresentationMutation({
 *   variables: {
 *      householdID: // value for 'householdID'
 *   },
 * });
 */
export function useCreateBlankClientPresentationMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlankClientPresentationMutation, CreateBlankClientPresentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlankClientPresentationMutation, CreateBlankClientPresentationMutationVariables>(CreateBlankClientPresentationDocument, options);
      }
export type CreateBlankClientPresentationMutationHookResult = ReturnType<typeof useCreateBlankClientPresentationMutation>;
export type CreateBlankClientPresentationMutationResult = Apollo.MutationResult<CreateBlankClientPresentationMutation>;
export type CreateBlankClientPresentationMutationOptions = Apollo.BaseMutationOptions<CreateBlankClientPresentationMutation, CreateBlankClientPresentationMutationVariables>;